import { FC } from 'react';
import { FormControl, FormLabel, Switch } from '@chakra-ui/react';

type BlockedUserToggleType = {
  onClick: () => void;
  includeBlocked: boolean | null | undefined;
};

export const ShowBlockedUserToggle: FC<BlockedUserToggleType> = ({
  onClick,
  includeBlocked,
}) => {
  return (
    <FormControl display="flex" alignItems="center">
      <Switch
        size="sm"
        onChange={onClick}
        id="show-blocked-users"
        marginRight={2}
        isChecked={includeBlocked || false}
        data-testid="show-blocked-user-toggle"
        shadow="sm"
      />
      <FormLabel htmlFor="show-blocked-users" mb="0">
        Include blocked users
      </FormLabel>
    </FormControl>
  );
};
